(() => {
  // ===== Root / Elements =====
  const $root = document.querySelector('[data-ats-delivery]');
  if (!$root) return;

  const $ = (sel) => $root.querySelector(sel);

  const $input = $('[data-ats-delivery-input]');
  const $button = $('[data-ats-delivery-btn]');
  const $message = $('[data-ats-delivery-msg]');
  const $dateTitle = $('[data-ats-date-title]');

  // Style-1 (tabs + timelines)
  const $tabs = $('[data-ats-delivery-tabs]');
  const $tabBtns = $root.querySelectorAll('[data-ats-tab-btn]');
  const $tabPanels = $root.querySelectorAll('[data-ats-tab-panel]');
  const $timelineFast = $('[data-ats-delivery-timeline-fast]');
  const $timelineStd = $('[data-ats-delivery-timeline-std]');

  // Style-2 (2 lines summary)
  const $summary = $('[data-ats-delivery-summary]');
  const $summaryStd = $('[data-ats-summary-std]');
  const $summaryFast = $('[data-ats-summary-fast]');

  // Custom date picker
  const $customDateWrap = $('[data-ats-custom-date-wrap]');
  const $customDateInput = $('[data-ats-custom-date-input]');

  let atsDatePicker = null;
  let selectedDeliveryType = '';
  let selectedDeliveryDate = '';
  let defaultStandardDeliveryDate = '';

  const CUSTOM_DATE_CHARGE_ENABLED = $root.dataset.customDateChargeEnabled === 'true';
  const CUSTOM_DATE_CHARGE_VARIANT_ID = Number($root.dataset.customDateChargeVariant || 0);
  const SKIP_SUNDAYS = $root.dataset.skipSundays === 'true';

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  // ===== Settings from data-* =====
  const csvUrl = ($root.dataset.csv || '').trim();
  const dateFormat = ($root.dataset.format || 'MMM_DD').trim();

  const TEXT_LOADING = $root.dataset.loading || 'Checking...';
  const TEXT_INVALID = $root.dataset.invalid || 'Please enter a valid 6-digit pincode.';
  const TEXT_NOTFOUND = $root.dataset.notfound || 'Sorry, delivery is not available to this pincode.';

  const MODE_STD = $root.dataset.modeStd || 'Standard Delivery';
  const MODE_FAST = $root.dataset.modeFast || 'Express Delivery';

  const LABEL_ORDERED = $root.dataset.l1 || 'Ordered';
  const LABEL_SHIPPED = $root.dataset.l2 || 'Shipped';
  const LABEL_DELIVERED = $root.dataset.l3 || 'Delivered';

  const UI_STYLE = ($root.dataset.uiStyle || 'style1').trim(); // "style1" | "style2"

  const productPinCollections = (($root.dataset.collections || '').trim())
    .split(',')
    .map((h) => h.trim().toLowerCase())
    .filter(Boolean)
    .filter((h) => h.startsWith('pin-'));

  const isCollectionScope = (scope) => (scope || '').toLowerCase().startsWith('collection:');
  const scopeHandle = (scope) => (scope || '').split(':').slice(1).join(':').trim().toLowerCase();

  if (!csvUrl || !$input || !$button || !$message) return;

  if (UI_STYLE === 'style1' && (!$timelineFast || !$timelineStd)) return;
  if (UI_STYLE === 'style2' && (!$summary || !$summaryStd || !$summaryFast)) return;

  // ===== Helpers =====
  const PIN_REGEX = /^[0-9]{6}$/;

  const setMessage = (text, isError = false) => {
    $message.textContent = text || '';
    $message.classList.toggle('is-error', !!text && isError);
  };

  const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + Number(days || 0));
    return d;
  };

  const addDaysSkipSundays = (date, days) => {
    const d = new Date(date);
    let remaining = Number(days || 0);

    while (remaining > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) remaining--;
    }

    return d;
  };

  const skipSunday = (date) => {
    const d = new Date(date);

    while (d.getDay() === 0) {
      d.setDate(d.getDate() + 1);
    }

    return d;
  };

  const toInputDate = (date) => {
    const d = new Date(date);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const getProductForm = () => {
    const section = $root.closest('[data-section-type="product"]');
    return section?.querySelector('form.product-single__form') ||
      document.querySelector('form.product-single__form');
  };

  /** All line item properties on the product form (personalization app, Globo, ATS, etc.). */
  const collectFormLineItemProperties = (form) => {
    const out = {};
    if (!form) return out;

    form
      .querySelectorAll(
        'input[name^="properties["], textarea[name^="properties["], select[name^="properties["]'
      )
      .forEach((el) => {
        if (el.disabled) return;

        const name = el.name || '';
        const match = name.match(/^properties\[(.+)\]$/);
        if (!match) return;

        const key = match[1];
        if (el.value == null) return;

        out[key] = String(el.value);
      });

    return out;
  };

  const syncCustomDateToProductForm = () => {
    const form = getProductForm();
    if (!form || !$customDateInput) return;

    let hiddenInput = form.querySelector('[data-ats-custom-date-hidden]');
    const value = $customDateInput.value || '';

    if (!value) {
      if (hiddenInput) hiddenInput.remove();
      return;
    }

    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'properties[Custom Delivery Date]';
      hiddenInput.setAttribute('data-ats-custom-date-hidden', '');
      form.appendChild(hiddenInput);
    }

    hiddenInput.value = value;
  };

const toPropertyDate = (isoDate) => {
  const parts = (isoDate || '').split('-');
  if (parts.length !== 3) return isoDate;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
};

const setDeliveryChoice = (type, date) => {
  setMessage('');

  const propertyDate = toPropertyDate(date);

  selectedDeliveryType = type;
  selectedDeliveryDate = propertyDate;

  $summaryStd?.classList.toggle('is-selected', type === 'Standard');
  $customDateWrap?.classList.toggle('is-selected', type === 'Custom');

  const form = getProductForm();
  if (!form) return;

  const setHidden = (selector, name, value) => {
    let input = form.querySelector(selector);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute(selector.replace('[', '').replace(']', ''), '');
      form.appendChild(input);
    }

    input.value = value;
  };

  setHidden('[data-ats-delivery-date-hidden]', 'properties[Delivery Date]', propertyDate);
  setHidden('[data-ats-delivery-type-hidden]', 'properties[Delivery Type]', type);
};

  const addDatePickerControls = (fp) => {
    if (!fp?.calendarContainer) return;
    if (fp.calendarContainer.querySelector('[data-ats-date-footer]')) return;

    const footer = document.createElement('div');
    footer.className = 'ATS-delivery-date-footer';
    footer.setAttribute('data-ats-date-footer', '');

    footer.innerHTML = `
      <button type="button" class="ATS-delivery-date-footer__btn" data-ats-date-clear>
        CLEAR
      </button>
    `;

    footer.querySelector('[data-ats-date-clear]').addEventListener('click', () => {
      fp.clear();

      selectedDeliveryType = '';
      selectedDeliveryDate = '';

      $summaryStd?.classList.remove('is-selected');
      $customDateWrap?.classList.remove('is-selected');

      const form = getProductForm();
      form?.querySelector('[data-ats-delivery-date-hidden]')?.remove();
      form?.querySelector('[data-ats-delivery-type-hidden]')?.remove();

      syncCustomDateToProductForm();
    });

    fp.calendarContainer.appendChild(footer);
  };

  const initCustomDatePicker = () => {
    if (!$customDateInput) return null;
    if (atsDatePicker) return atsDatePicker;
    if (typeof window.flatpickr !== 'function') return null;

    atsDatePicker = window.flatpickr($customDateInput, {
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'd-m-Y',
      altInputClass: 'ATS-delivery__date-picker',
      allowInput: false,
      disableMobile: true,
      appendTo: document.body,
      monthSelectorType: 'static',
      closeOnSelect: true,

      onReady: function (_selectedDates, _dateStr, fp) {
        fp.calendarContainer.classList.add('ATS-delivery-calendar');
        addDatePickerControls(fp);
      },

      onOpen: function (_selectedDates, _dateStr, fp) {
        fp.calendarContainer.classList.add('ATS-delivery-calendar');
        addDatePickerControls(fp);
      },

      onChange: function () {
        const date = ($customDateInput?.value || '').trim();
        if (date) setDeliveryChoice('Custom', date);
      }
    });

    return atsDatePicker;
  };

  const setupCustomDatePicker = (deliveredDate) => {
    if (!$customDateWrap || !$customDateInput) return;

    const minDateValue = toInputDate(deliveredDate);

    $customDateWrap.style.display = 'block';

    if ($dateTitle) $dateTitle.style.display = 'block';

    const fp = initCustomDatePicker();

    if (fp) {
      fp.set('minDate', minDateValue);
      fp.clear();
      fp.jumpToDate(minDateValue);
      fp.redraw();

      if (fp.altInput) {
        fp.altInput.placeholder = '🗓️ Select Date';
      }
    } else {
      $customDateInput.setAttribute('type', 'date');
      $customDateInput.min = minDateValue;
      $customDateInput.value = '';
    }

    syncCustomDateToProductForm();
  };

  const clearUI = () => {
    selectedDeliveryType = '';
    selectedDeliveryDate = '';
    defaultStandardDeliveryDate = '';

    const form = getProductForm();
    form?.querySelector('[data-ats-delivery-date-hidden]')?.remove();
    form?.querySelector('[data-ats-delivery-type-hidden]')?.remove();

    if ($timelineFast) $timelineFast.innerHTML = '';
    if ($timelineStd) $timelineStd.innerHTML = '';
    if ($tabs) $tabs.style.display = 'none';

    if ($summary) $summary.style.display = 'none';

    if ($dateTitle) $dateTitle.style.display = 'none';

    const stdSpan = $summaryStd?.querySelector('span');
    const fastSpan = $summaryFast?.querySelector('span');

    if (stdSpan) stdSpan.textContent = '';
    if (fastSpan) fastSpan.textContent = '';

    if ($customDateWrap) $customDateWrap.style.display = 'none';

    if (atsDatePicker) {
      atsDatePicker.clear();
      atsDatePicker.set('minDate', null);
    }

    if ($customDateInput) {
      $customDateInput.value = '';
      $customDateInput.removeAttribute('min');
    }

    syncCustomDateToProductForm();
  };

  const formatDate = (d) => {
    const day = String(d.getDate()).padStart(2, '0');
    const monShort = d.toLocaleString('en-US', { month: 'short' });
    const monNum = String(d.getMonth() + 1).padStart(2, '0');
    const yr = d.getFullYear();

    if (dateFormat === 'DD_MMM') return `${day} ${monShort}`;
    if (dateFormat === 'DD_MM_YYYY') return `${day}/${monNum}/${yr}`;
    return `${monShort} ${day}`;
  };

  // ===== Tabs =====
  const setActiveTab = (key) => {
    $tabBtns.forEach((b) => b.classList.toggle('is-active', b.dataset.atsTabBtn === key));
    $tabPanels.forEach((p) => p.classList.toggle('is-active', p.dataset.atsTabPanel === key));
    localStorage.setItem('ats_delivery_tab', key);
  };

  if ($tabBtns?.length) {
    $tabBtns.forEach((btn) => {
      btn.addEventListener('click', () => setActiveTab(btn.dataset.atsTabBtn));
    });
  }

  // ===== CSV Parser =====
  const parseCSVLine = (line) => {
    const out = [];
    let cur = '';
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const ch = line[i];

      if (ch === '"') {
        if (inQuotes && line[i + 1] === '"') {
          cur += '"';
          i++;
        } else {
          inQuotes = !inQuotes;
        }
        continue;
      }

      if (ch === ',' && !inQuotes) {
        out.push(cur.trim());
        cur = '';
        continue;
      }

      cur += ch;
    }

    out.push(cur.trim());
    return out;
  };

  const parseCSVToObjects = (csvText) => {
    const lines = csvText.replace(/\r/g, '').split('\n').filter(Boolean);
    if (!lines.length) return [];

    const header = parseCSVLine(lines[0]).map((h) => (h || '').toLowerCase());

    const idxScope = header.indexOf('product_scope');
    const idxPin = header.indexOf('pincode');
    const idxPrepStd = header.indexOf('prep_std');
    const idxShipStd = header.indexOf('ship_std');
    const idxPrepFast = header.indexOf('prep_fast');
    const idxShipFast = header.indexOf('ship_fast');
    const idxCutoff = header.indexOf('cutoff_time');

    const get = (cells, idx, fallbackIdx) => (cells[idx >= 0 ? idx : fallbackIdx] || '').trim();

    const rows = [];

    for (let i = 1; i < lines.length; i++) {
      const cells = parseCSVLine(lines[i]);
      if (!cells || cells.length < 3) continue;

      const scope = get(cells, idxScope, 0) || '*';

      const pinCell = get(cells, idxPin, 1);
      const pins = pinCell
        .split(',')
        .map((x) => x.trim())
        .filter(Boolean);

      const prepStd = get(cells, idxPrepStd, 2) === '' ? null : Number(get(cells, idxPrepStd, 2));
      const shipStd = get(cells, idxShipStd, 3) === '' ? null : Number(get(cells, idxShipStd, 3));
      const prepFast = get(cells, idxPrepFast, 4) === '' ? null : Number(get(cells, idxPrepFast, 4));
      const shipFast = get(cells, idxShipFast, 5) === '' ? null : Number(get(cells, idxShipFast, 5));
      const cutoffTime = get(cells, idxCutoff, -1);

      rows.push({
        scope,
        pins,
        prepStd: Number.isFinite(prepStd) ? prepStd : null,
        shipStd: Number.isFinite(shipStd) ? shipStd : null,
        prepFast: Number.isFinite(prepFast) ? prepFast : null,
        shipFast: Number.isFinite(shipFast) ? shipFast : null,
        cutoffTime
      });
    }

    return rows;
  };

  let cachedRows = null;

  const fetchDeliveryRows = async () => {
    if (cachedRows) return cachedRows;

    const res = await fetch(csvUrl, { cache: 'no-store' });
    if (!res.ok) throw new Error('CSV_FETCH_FAILED');

    const csvText = await res.text();
    cachedRows = parseCSVToObjects(csvText);
    return cachedRows;
  };

  const isAfterCutoff = (cutoffTime) => {
    if (!cutoffTime) return false;

    const value = cutoffTime.trim();
    if (!value) return false;

    const parts = value.split(':');
    if (parts.length !== 2) return false;

    const hour = Number(parts[0]);
    const minute = Number(parts[1]);

    if (!Number.isFinite(hour) || !Number.isFinite(minute)) return false;

    const now = new Date();
    const cutoff = new Date();
    cutoff.setHours(hour, minute, 0, 0);

    return now > cutoff;
  };

  const findDeliveryRow = (rows, pin) => {
    let defaultRow = null;
    let bestOverride = null;

    for (const r of rows) {
      if (!r?.pins?.length) continue;
      if (!r.pins.includes(pin)) continue;

      const scope = (r.scope || '*').trim();

      if (scope === '*') {
        defaultRow = r;
        continue;
      }

      if (isCollectionScope(scope)) {
        const handle = scopeHandle(scope);
        if (handle && productPinCollections.includes(handle)) {
          bestOverride = r;
          break;
        }
      }
    }

    return bestOverride || defaultRow;
  };

  // ===== UI Render Style 1 =====
  const renderTimelineInto = ($target, orderedDate, shippedDate, deliveredDate) => {
    if (!$target) return;

    $target.innerHTML = `
      <div class="ATS-delivery__step-marker1">
        <div class="ATS-delivery__step">
          <div class="timeline-layout--svg tw-mb-4">
            <img class="timeline-layout--svg--icon timeline-layout--svg--icon--convert-color"
                 src="https://storage.synctrack.io/megamind-estimated/icon-timeline/icon%20svg/order1.svg"
                 alt="order icon" width="20" height="20">
          </div>
          <div class="ATS-delivery__title ATS-caption tw-font-semibold">${LABEL_ORDERED}</div>
          <div class="ATS-delivery__date ATS-caption">${formatDate(orderedDate)}</div>
        </div>
      </div>

      <div class="ATS-delivery__step-marker2">
        <div class="ATS-delivery__step">
          <div class="timeline-layout--svg tw-mb-4">
            <img class="timeline-layout--svg--icon timeline-layout--svg--icon--convert-color"
                 src="https://storage.synctrack.io/megamind-estimated/icon-timeline/icon%20svg/delivery1.svg"
                 alt="shipped icon" width="20" height="20">
          </div>
          <div class="ATS-delivery__title ATS-caption tw-font-semibold">${LABEL_SHIPPED}</div>
          <div class="ATS-delivery__date ATS-caption">${formatDate(shippedDate)}</div>
        </div>
      </div>

      <div class="ATS-delivery__step">
        <div class="timeline-layout--svg tw-mb-4">
          <img class="timeline-layout--svg--icon timeline-layout--svg--icon--convert-color"
               src="https://storage.synctrack.io/megamind-estimated/icon-timeline/icon%20svg/location1.svg"
               alt="delivered icon" width="20" height="20">
        </div>
        <div class="ATS-delivery__title ATS-caption tw-font-semibold">${LABEL_DELIVERED}</div>
        <div class="ATS-delivery__date ATS-caption">${formatDate(deliveredDate)}</div>
      </div>
    `;
  };

  // ===== UI Render Style 2 =====
  const renderSummary = (orderedDate, deliveredStd, deliveredFast, row) => {
    if (!$summary || !$summaryStd || !$summaryFast) return;

    const byText = (d) =>
      d.toLocaleString('en-GB', { day: '2-digit', month: 'long' });

    selectedDeliveryType = '';
    selectedDeliveryDate = '';

    $summaryStd.classList.remove('is-selected');
    $customDateWrap?.classList.remove('is-selected');

    if (row.prepStd === null || row.shipStd === null) {
      $summaryStd.style.display = 'none';
    } else {
      $summaryStd.style.display = '';
    }

    if (row.prepFast === null || row.shipFast === null) {
      $summaryFast.style.display = 'none';
    } else {
      $summaryFast.style.display = '';
    }

    $summaryStd.querySelector('span').textContent = `${byText(deliveredStd)}`;
    $summaryStd.dataset.deliveryDate = toInputDate(deliveredStd);

    $summaryFast.querySelector('span').textContent = `${MODE_FAST} by ${byText(deliveredFast)}`;

    $summary.style.display = '';
  };

  // ===== Main Action =====
  const checkPincode = async () => {
    const pin = ($input.value || '').trim();

    setMessage('');
    clearUI();

    if (!PIN_REGEX.test(pin)) {
      setMessage(TEXT_INVALID);
      return;
    }

    setMessage(TEXT_LOADING);

    try {
      const rows = await fetchDeliveryRows();
      const row = findDeliveryRow(rows, pin);

      await sleep(400);

      if (!row) {
        setMessage(TEXT_NOTFOUND);
        return;
      }

      const orderedDate = new Date();
      const extraDay = isAfterCutoff(row.cutoffTime) ? 1 : 0;

      // STANDARD with Sunday skip
      const addFn = SKIP_SUNDAYS ? addDaysSkipSundays : addDays;

      const effectivePrepStd = Number(row.prepStd || 0) + extraDay;
      const shippedStd = addFn(orderedDate, effectivePrepStd);
      const deliveredStd = addFn(shippedStd, row.shipStd);

      const firstAvailableStdDate = SKIP_SUNDAYS ? skipSunday(deliveredStd) : deliveredStd;
      defaultStandardDeliveryDate = toInputDate(firstAvailableStdDate);

      // EXPRESS / FAST
      const effectivePrepFast = Number(row.prepFast || 0) + extraDay;
      const shippedFast = addDays(orderedDate, effectivePrepFast);
      const deliveredFast = addDays(shippedFast, row.shipFast);

      // Custom date starts from standard available date
      setupCustomDatePicker(firstAvailableStdDate);

      if (UI_STYLE === 'style2') {
        renderSummary(orderedDate, firstAvailableStdDate, deliveredFast, row);

        // Default Standard selected after pincode check
        setDeliveryChoice('Standard', defaultStandardDeliveryDate);

        setMessage('');
        localStorage.setItem('ats_delivery_pin', pin);
        return;
      }

      // Style 1
      if ($tabs) $tabs.style.display = '';

      renderTimelineInto($timelineStd, orderedDate, shippedStd, firstAvailableStdDate);
      renderTimelineInto($timelineFast, orderedDate, shippedFast, deliveredFast);

      const savedTab = localStorage.getItem('ats_delivery_tab');
      setActiveTab(savedTab === 'fast' ? 'fast' : 'std');

      // Default Standard selected after pincode check
      setDeliveryChoice('Standard', defaultStandardDeliveryDate);

      setMessage('');
      localStorage.setItem('ats_delivery_pin', pin);
    } catch (err) {
      console.error(err);
      setMessage(TEXT_NOTFOUND);
    }
  };

  const useStandardDateIfNoChoice = () => {
    if (selectedDeliveryDate) return;

    const stdDate =
      defaultStandardDeliveryDate ||
      $summaryStd?.dataset.deliveryDate ||
      '';

    if (stdDate) {
      setDeliveryChoice('Standard', stdDate);
    }
  };

  const addDeliveryPropertiesToRequestBody = (body) => {
    useStandardDateIfNoChoice();

    // If pincode was never checked, no delivery date will be added.
    if (!selectedDeliveryDate || !body) return body;

    const deliveryType = selectedDeliveryType || 'Standard';
    const formProperties = collectFormLineItemProperties(getProductForm());

    if (body instanceof FormData) {
      for (const [key, value] of Object.entries(formProperties)) {
        body.set(`properties[${key}]`, value);
      }
      body.set('properties[Delivery Date]', selectedDeliveryDate);
      body.set('properties[Delivery Type]', deliveryType);
      return body;
    }

    if (body instanceof URLSearchParams) {
      for (const [key, value] of Object.entries(formProperties)) {
        body.set(`properties[${key}]`, value);
      }
      body.set('properties[Delivery Date]', selectedDeliveryDate);
      body.set('properties[Delivery Type]', deliveryType);
      return body;
    }

    if (typeof body === 'string') {
      try {
        const data = JSON.parse(body);

        if (Array.isArray(data.items)) {
          data.items = data.items.map((item, index) => {
            if (index > 0) return item;

            return {
              ...item,
              properties: {
                ...formProperties,
                ...(item.properties || {}),
                'Delivery Date': selectedDeliveryDate,
                'Delivery Type': deliveryType
              }
            };
          });
        } else {
          data.properties = {
            ...formProperties,
            ...(data.properties || {}),
            'Delivery Date': selectedDeliveryDate,
            'Delivery Type': deliveryType
          };
        }

        return JSON.stringify(data);
      } catch (err) {
        if (body.includes('=')) {
          const params = new URLSearchParams(body);
          for (const [key, value] of Object.entries(formProperties)) {
            params.set(`properties[${key}]`, value);
          }
          params.set('properties[Delivery Date]', selectedDeliveryDate);
          params.set('properties[Delivery Type]', deliveryType);
          return params.toString();
        }
      }
    }

    return body;
  };

  // ===== Events =====
  $button.addEventListener('click', checkPincode);

  $input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') checkPincode();
  });

  $summaryStd?.addEventListener('click', () => {
    const date = $summaryStd.dataset.deliveryDate;
    if (!date) return;

    atsDatePicker?.clear();

    if ($customDateInput) $customDateInput.value = '';

    setDeliveryChoice('Standard', date);
  });

  $customDateInput?.addEventListener('change', () => {
    const date = ($customDateInput?.value || '').trim();
    if (date) setDeliveryChoice('Custom', date);
  });

  document.addEventListener('mousedown', (e) => {
    const fp = atsDatePicker;
    if (!fp || !fp.isOpen || !fp.calendarContainer) return;

    const clickedInsideCalendar = fp.calendarContainer.contains(e.target);
    const clickedInput = fp.altInput?.contains(e.target) || $customDateInput?.contains(e.target);

    if (!clickedInsideCalendar && !clickedInput) {
      fp.close();
    }
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button, input[type="submit"], a');
    if (!btn) return;

    const btnText = (btn.textContent || btn.value || '').trim().toLowerCase();

    const isAddToCartBtn =
      btn.matches('[data-add-to-cart], button[name="add"], input[name="add"], .product-form__submit, .ProductForm__AddToCart, .shopify-payment-button__button') ||
      btnText.includes('add to cart') ||
      btnText.includes('buy now');

    if (!isAddToCartBtn) return;

    // No blocking now. It only applies Standard if pincode was already checked.
    useStandardDateIfNoChoice();
  }, true);

  // ===== Fetch intercept =====
  const atsOriginalFetch = window.fetch;

  window.fetch = function (resource, options = {}) {
    const url = typeof resource === 'string' ? resource : resource?.url || '';
    const method = (options.method || resource?.method || 'GET').toUpperCase();

    if (url.includes('/cart/add') && method === 'POST') {
      options = {
        ...options,
        body: addDeliveryPropertiesToRequestBody(options.body)
      };
    }

    return atsOriginalFetch.call(this, resource, options);
  };

  // ===== XHR intercept =====
  const atsOriginalXHROpen = XMLHttpRequest.prototype.open;
  const atsOriginalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._atsIsCartAddRequest =
      String(url || '').includes('/cart/add') &&
      String(method || 'GET').toUpperCase() === 'POST';

    return atsOriginalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this._atsIsCartAddRequest) {
      body = addDeliveryPropertiesToRequestBody(body);
    }

    return atsOriginalXHRSend.call(this, body);
  };

  // ===== Form submit for Custom Date charge logic =====
  document.addEventListener('submit', async (e) => {
    const form = e.target;

    if (!form.matches('form.product-single__form')) return;

    useStandardDateIfNoChoice();
    syncCustomDateToProductForm();

    const selectedDate = selectedDeliveryDate;

    // For Standard, let the theme's normal add-to-cart run.
    if (selectedDeliveryType !== 'Custom') return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const formData = new FormData(form);
    const mainVariantId = formData.get('id');
    const quantity = Number(formData.get('quantity') || 1);
  const groupId = `custom_date_${Date.now()}_${mainVariantId}`;
    const addBtn = form.querySelector('[data-add-to-cart]');

    const lineItemProperties = collectFormLineItemProperties(form);

    try {
      addBtn?.classList.add('btn--loading');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: (() => {
            const items = [
              {
                id: mainVariantId,
                quantity: quantity,
                properties: {
                  ...lineItemProperties,
                  'Delivery Date': selectedDate,
                'Delivery Type': 'Custom',
                // 'Custom Delivery Date': selectedDate,
                // '_custom_date_group': groupId
                }
              }
            ];

            if (CUSTOM_DATE_CHARGE_ENABLED && CUSTOM_DATE_CHARGE_VARIANT_ID) {
              items.push({
                id: CUSTOM_DATE_CHARGE_VARIANT_ID,
                quantity: quantity,
                properties: {
                  'Delivery Date': selectedDate,
                'Delivery Type': 'Custom',
                // 'Custom Delivery Date': selectedDate,
                // '_custom_date_group': groupId
                }
              });
            }

            return items;
          })()
        })
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.description || 'Unable to add product.');
      }

      window.location.href = '/cart';
    } catch (err) {
      console.error(err);
      setMessage(err.message || 'Something went wrong.', true);
    } finally {
      addBtn?.classList.remove('btn--loading');
    }
  }, true);

  // ===== Restore saved pin =====
  const savedPin = localStorage.getItem('ats_delivery_pin');
  if (savedPin && PIN_REGEX.test(savedPin)) $input.value = savedPin;
})();